export default __webpack_public_path__ + "static/media/purple-circled-tick.d8cc9b77.svg";